// extracted by mini-css-extract-plugin
export default {"input":"DebounceSearch_input__GEsjd"};